import React from 'react';
import '../css/termsconditions.css';
import { Helmet } from 'react-helmet-async';

const TermsConditions = () => {
  return (
    <div className="terms-page-wrapper">
      <Helmet>
        <title>Terms and Conditions | PolicySamjho User Agreement</title>
        <meta
          name="description"
          content="Read the terms and conditions governing your use of PolicySamjho. Clear, transparent policies to ensure trusted service and transparency."
        />
        <meta name="keywords" content="terms and conditions, user agreement, Policy Samjho terms, legal policy, insurance advice terms, website usage policy" />
        <link
          rel="canonical"
          href="https://policysamjho.com/terms-and-conditions/"
        />
        <meta name="robots" content="index, follow" />
        <meta property="og:title" content="Terms and Conditions | PolicySamjho User Agreement" />
        <meta
          property="og:description"
          content="Read the terms and conditions governing your use of PolicySamjho. Clear, transparent policies to ensure trusted service and transparency."
        />
        <meta property="og:url" content="https://policysamjho.com/terms-and-conditions/" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:title" content="Terms and Conditions | PolicySamjho User Agreement" />
        <meta
          name="twitter:description"
          content="Read the terms and conditions governing your use of PolicySamjho. Clear, transparent policies to ensure trusted service and transparency."
        />

        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebPage",
            "name": "Terms and Conditions",
            "url": "https://policysamjho.com/terms-and-conditions/",
            "description": "The terms and conditions governing the use of the Policy Samjho website and services.",
            "publisher": {
              "@type": "Organization",
              "name": "Policy Samjho",
              "url": "https://policysamjho.com/"
            }
          })}
        </script>
      </Helmet>

      <div className="terms-conditions-container">
        <h1 className="terms-main-title">Terms & Conditions</h1>

        <p className="terms-intro-text">
          Policy Samjho operates the website at <a href="https://policysamjho.com">https://policysamjho.com</a>.
          This document outlines the terms and conditions governing your use of our Website. The information provided here may be updated periodically.
        </p>

        <section className="terms-section">
          <h2>1. Acceptance of Terms</h2>
          <p>
            When you visit https://policysamjho.com, you acknowledge that you have read, understood, and agree to comply with these terms and conditions, as well as all relevant laws and regulations. You are responsible for ensuring compliance with applicable local laws. If you do not accept these terms, please refrain from using this Website. All content on this Website is protected under applicable intellectual property laws.
          </p>
        </section>

        <section className="terms-section">
          <h2>2. Limited Use Grant</h2>
          <p>
            You are permitted to temporarily access and view one copy of the content (including information or software) on the Website for personal, non-commercial purposes only. This constitutes a limited permission to use, not ownership transfer. Under this permission, you agree not to:
          </p>
          <ul>
            <li>alter, reproduce, or copy the content;</li>
            <li>utilize the content for commercial purposes or public exhibition;</li>
            <li>reverse engineer, decompile, or disassemble any software on the Website;</li>
            <li>remove proprietary notices, including copyright or trademark attributions; or</li>
            <li>redistribute the content or replicate it on other servers.</li>
          </ul>
          <p>
            This permission terminates automatically upon violation of these restrictions and may be revoked by Policy Samjho at any time. Upon termination, you must delete all downloaded content from your devices.
          </p>
        </section>

        <section className="terms-section">
          <h2>3. No Warranties</h2>
          <p>
            All content on the Website is provided without warranties of any kind, whether express or implied. Policy Samjho specifically disclaims all warranties, including but not limited to implied warranties of merchantability, suitability for a specific purpose, and non-infringement of third-party rights.
          </p>
          <p>
            Policy Samjho does not guarantee the accuracy, completeness, reliability, or appropriateness of the content on the Website or any third-party websites accessible through links.
          </p>
        </section>

        <section className="terms-section">
          <h2>4. Limitation of Liability</h2>
          <p>
            Policy Samjho and its affiliates shall not be held liable for any direct, indirect, incidental, consequential, or special damages arising from your use of or inability to use the Website, including but not limited to loss of data, revenue loss, or service interruption, even if Policy Samjho has been advised of the potential for such damages. Note that certain jurisdictions may not permit such limitations.
          </p>
        </section>

        <section className="terms-section">
          <h2>5. Content Accuracy</h2>
          <p>
            The Website may contain inaccuracies, errors, or outdated information. Policy Samjho does not guarantee that all content is error-free, comprehensive, or current. We reserve the right to modify, update, or remove content at our discretion without prior notice or obligation.
          </p>
        </section>

        <section className="terms-section">
          <h2>6. Third-Party Links</h2>
          <p>
            Policy Samjho is not responsible for examining or evaluating external websites linked from our Website. We do not endorse or assume responsibility for the content, products, or services offered on linked websites. Accessing third-party websites is entirely at your own risk.
          </p>
        </section>

        <section className="terms-section">
          <h2>7. Changes to Terms</h2>
          <p>
            Policy Samjho reserves the right to modify these terms and conditions at any time without advance notification. Your continued use of the Website following any changes constitutes acceptance of the revised terms.
          </p>
        </section>

        <section className="terms-section">
          <h2>8. Applicable Law</h2>
          <p>
            These terms and conditions shall be interpreted and governed according to the laws of India. Any disputes arising from these terms or your use of the Website shall be subject to the exclusive jurisdiction of the courts located in Indore, Madhya Pradesh, India.
          </p>
        </section>
      </div>
    </div>
  );
};

export default TermsConditions;